export enum MaterialCategory {
  FLOOR_TILES = "floor_tiles",
  SPLASHBACK = "splashback",
  BATH_TILES = "bath_tiles",
  BENCHTOPS = "benchtops",
  CABINETS = "cabinets",
  CARPETS = "carpets",
  PAINT = "paint",
}
